import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

function ReportBox({ title, description, reportType, accept, bankId, methodId, onDone }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const upload = async () => {
    if (!file) return toast.error("Choose the report file first");
    if (!bankId) return toast.error("Choose a bank account first");
    const body = new FormData();
    body.append("file", file); body.append("report_type", reportType);
    body.append("bank_account_id", bankId); body.append("method_id", methodId);
    setBusy(true);
    try {
      const { data } = await api.post("/sales/publicbank/import-native", body, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`${title}: ${data.inserted} imported, ${data.duplicate} duplicate, ${data.rejected} rejected · Gross RM ${Number(data.gross || 0).toLocaleString("en-MY", { minimumFractionDigits: 2 })}`);
      setFile(null); onDone?.();
    } catch (error) { toast.error(apiError(error)); }
    finally { setBusy(false); }
  };
  return <div className="border border-slate-200 rounded-sm p-4 bg-white">
    <h4 className="font-semibold text-sm text-slate-900">{title}</h4>
    <p className="text-xs text-slate-500 mt-1 mb-3">{description}</p>
    <Label className="text-xs">Report file</Label>
    <div className="flex flex-col sm:flex-row gap-2 mt-1">
      <input className="flex-1 text-sm border rounded-sm p-2" type="file" accept={accept}
        onChange={(event) => setFile(event.target.files?.[0] || null)} />
      <Button onClick={upload} disabled={busy || !file} className="bg-blue-600 hover:bg-blue-700">
        {busy ? "Importing..." : "Import & reconcile"}
      </Button>
    </div>
  </div>;
}

export default function PBReportImport({ bankId, methodId = "credit", onDone }) {
  return <div className="space-y-3">
    <div className="rounded-sm border border-blue-200 bg-blue-50 p-3 text-xs text-blue-900">
      Upload each source once. The system keeps QR and Card separately, prevents duplicate rows, and treats MDR as an expected fee—not an unexplained sales variance.
    </div>
    <div className="grid lg:grid-cols-2 gap-3">
      <ReportBox title="PB DuitNow QR monthly report" reportType="qr_monthly" accept=".xlsx"
        description="EBQR028 Excel workbook. Every outlet worksheet is read; the QR reference controls the transaction date."
        bankId={bankId} methodId={methodId} onDone={onDone} />
      <ReportBox title="PB Card Merchant Sales Summary" reportType="card_summary" accept=".csv"
        description="Sales Summary CSV. Imports gross card sales, MDR merchant fees and net deposit by DBA/deposit date."
        bankId={bankId} methodId={methodId} onDone={onDone} />
    </div>
  </div>;
}
